export default "__VITE_ASSET__Uqdfj7Z0__"